import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { observer } from 'mobx-react-lite';
import React, { useEffect, useRef, useState } from 'react';
import { getEdgeCenter, getMarkerEnd, Position } from 'react-flow-renderer';
import styled from 'styled-components';
import { UiConstants } from '../../data/UiConstants';
import { actionEdgeId } from '../../helper/reactHelpers';
import { ActionEditorChangeGroup, groupUndoableActionEditorChanges } from '../../stores/undo/operation/ActionEditorSubmitChangesOp';
import { doScale, doScaleNumber, getBezierPathEx } from './actionEditorHelpers';
import { RiScissorsCutLine } from "react-icons/ri";
import { actionEditorStore } from '../../stores/ActionEditorStore';
import { localSettingsStore } from '../../stores/LocalSettingsStore';
const DeleteButton = styled.button.withConfig({
  displayName: "ActionEdge__DeleteButton",
  componentId: "sc-1flzisv-0"
})(["color:#000000;font-size:", ";width:", ";height:", ";border-radius:100%;z-index:", ";pointer-events:all;cursor:pointer;&:hover{color:red;}"], props => doScale(14, props.scale), props => doScale(18, props.scale), props => doScale(18, props.scale), UiConstants.Z_INDEX_ACTION_EDITOR_EDGE_DELETE_BUTTON);

const onEdgeClick = (event, id) => {
  event.stopPropagation();
  const actionTree = actionEditorStore.currentActionSubTree;
  groupUndoableActionEditorChanges(ActionEditorChangeGroup.DeleteEdge, () => {
    actionTree.allActions.forEach(from => {
      from.exits().forEach((exit, exitIndex) => {
        exit.nextActions.forEach(to => {
          if (actionEdgeId(from.$modelId, exitIndex, to) === id) {
            exit.removeNextAction(to);
          }
        });
      });
    });
  });
};

export const ActionEdge = observer(({
  id,
  source,
  target,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  data,
  arrowHeadType,
  markerEndId
}) => {
  var _ref$current2;

  const {
    currentAction
  } = actionEditorStore;
  const [isHover, setIsHover] = useState(false);
  const scale = data.scale;
  const sourceIsTarget = source === target;
  const curvature = (sourceIsTarget ? 10 : 7) * 0.05 * Math.sqrt(scale * actionEditorStore.actionEditorUpscaleFactor);

  if (sourceIsTarget) {
    const offset = doScaleNumber(6.4, scale);
    sourceX -= offset * 2;
    sourcePosition = Position.Left;
    targetX += offset * 2;
    targetPosition = Position.Right;
    /*
    if (sourceY === targetY) {
        sourceX -= offset;
        sourceY += offset;
        sourcePosition = Position.Bottom;
         //targetX += offset;
        //targetY -= offset;
        //targetPosition = Position.Top;
         targetX += offset * 2;
        targetPosition = Position.Right;
    } else {
        sourceX -= offset * 2;
        sourcePosition = Position.Left;
         targetX += offset * 2;
        targetPosition = Position.Right;
    }
    */
  }

  const edgePath = getBezierPathEx({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
    curvature
  })[0]; //const edgePath = getBezierPath({ sourceX, sourceY, sourcePosition, targetX, targetY, targetPosition });

  const markerEnd = getMarkerEnd(arrowHeadType, markerEndId);
  const [edgeCenterX, edgeCenterY] = getEdgeCenter({
    sourceX,
    sourceY,
    targetX,
    targetY
  });
  const {
    actionTreeValidationEnabled
  } = localSettingsStore;
  const showDetails = (currentAction === null || currentAction === void 0 ? void 0 : currentAction.$modelId) === source || (currentAction === null || currentAction === void 0 ? void 0 : currentAction.$modelId) === target;
  const foreignObjectSize = doScaleNumber(40, scale);
  const foreignObjectStyle = {
    pointerEvents: 'none'
  };
  const markAsDisconnected = actionTreeValidationEnabled && actionEditorStore.shouldMarkAsDisconnected(data.fromAction, actionEditorStore.currentActionSubTree);
  const color = "#32CD32";
  style.strokeWidth = doScale(2, scale);
  style.stroke = color;
  style.opacity = markAsDisconnected ? 0.3 : 0.7;

  const styleHover = _objectSpread(_objectSpread({}, style), {}, {
    strokeWidth: doScale(2, scale),
    stroke: UiConstants.COLOR_SELECTION_HIGHLIGHT
  });

  function onMouseEnterDisconnectButton() {
    setIsHover(true);
  }

  function onMouseLeaveDisconnectButton() {
    setIsHover(false);
  }

  const ref = useRef();
  useEffect(() => {
    var _ref$current;

    if ((_ref$current = ref.current) !== null && _ref$current !== void 0 && _ref$current.parentElement) {
      const svg = ref.current.parentElement.parentElement.parentElement;
      const defs = svg.children.item(0);
      const marker = defs.children.item(0);
      const polyline = marker.children.item(0);
      polyline.setAttribute("stroke", color);
      polyline.setAttribute("fill", color);
    }
  }, [(_ref$current2 = ref.current) === null || _ref$current2 === void 0 ? void 0 : _ref$current2.parentElement, color]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    id: id,
    ref: ref,
    style: isHover ? styleHover : style,
    className: "react-flow__edge-path",
    d: edgePath,
    markerEnd: markerEnd,
    onMouseEnter: onMouseEnterDisconnectButton,
    onMouseLeave: onMouseLeaveDisconnectButton
  }), showDetails && /*#__PURE__*/React.createElement("foreignObject", {
    width: foreignObjectSize,
    height: foreignObjectSize,
    x: edgeCenterX - foreignObjectSize / 4.5,
    y: edgeCenterY - foreignObjectSize / 4.5,
    style: foreignObjectStyle,
    requiredExtensions: "http://www.w3.org/1999/xhtml"
  }, /*#__PURE__*/React.createElement(DeleteButton, {
    scale: scale,
    onClick: event => onEdgeClick(event, id),
    onMouseEnter: onMouseEnterDisconnectButton,
    onMouseLeave: onMouseLeaveDisconnectButton
  }, /*#__PURE__*/React.createElement(RiScissorsCutLine, null))));
});